import { Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from './service/auth/auth.guard';
import { LoginComponent } from './route/authentication/login/login.component';
import { UploadPageComponent } from './route/home/sales/installations/upload-page/upload-page.component';
import { ResetPasswordComponent } from './route/authentication/reset-password/reset-password.component';
import { InviteAcceptanceComponent } from './route/home/settings/users/invite-acceptance/invite-acceptance.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'reset', component: ResetPasswordComponent },
  { path: 'home', loadChildren: () => import('./route/home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
  { path: 'settings', loadChildren: () => import('./route/home/settings/settings.module').then(m => m.SettingsModule), canActivate: [AuthGuard] },
  { path: 'uploads', component: UploadPageComponent },
  { path: 'invite', component: InviteAcceptanceComponent },

  // Not Found
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
